import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';

const Navigation: React.FC = () => {
  const location = useLocation();

  return (
    <nav className="main-navigation">
      <div className="nav-brand">
        <Link to="/">⚡ Symmetry CA - Turing Complete</Link>
      </div>
      <ul className="nav-links">
        <li className={location.pathname === '/' ? 'active' : ''}>
          <Link to="/">
            <span>🎨</span>
            <span>Visualizer</span>
          </Link>
        </li>
        <li className={location.pathname === '/turing-machine' ? 'active' : ''}>
          <Link to="/turing-machine">
            <span>🤖</span>
            <span>Turing Machine</span>
          </Link>
        </li>
        <li className={location.pathname === '/turing-machine/detailed' ? 'active' : ''}>
          <Link to="/turing-machine/detailed">
            <span>📊</span>
            <span>Detailed Tests</span>
          </Link>
        </li>
        <li className={location.pathname === '/calculator' ? 'active' : ''}>
          <Link to="/calculator">
            <span>🧮</span>
            <span>TM Calculator</span>
          </Link>
        </li>
        <li className={location.pathname === '/research' ? 'active' : ''}>
          <Link to="/research">
            <span>📚</span>
            <span>Research</span>
          </Link>
        </li>
        <li className={location.pathname === '/ultra-deep-fusion' ? 'active' : ''}>
          <Link to="/ultra-deep-fusion">
            <span>⚡</span>
            <span>Ultra-Deep Fusion</span>
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navigation;
